<template>
    <XIASearchBar :searchData="searchData" @search="search"/>
    <div class="title">
       租赁日志
    </div>
    <TableComponent :tableObjet="tableObjet" :headers="headers">

    </TableComponent>
</template>

<script setup>
import TableComponent from '@/components/TableComponent.vue';
import XIASearchBar from '@/components/XIA-SearchBar.vue';
import {useStartLog} from "@/use/sysLog"

const {tableObjet,search,searchData,headers}=useStartLog()
</script>